module.exports = __webpack_public_path__ + "static/media/close-story.906efd5e.svg";